import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {StepperComponent} from './stepper/stepper.component';
import {HomeComponent} from './home/home.component';
import {NumbersOverviewComponent} from './numbers-overview/numbers-overview.component';
import {ResultsOverviewComponent} from './results-overview/results-overview.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'startSimulation', component: StepperComponent },
  { path: 'numbersOverview', component: NumbersOverviewComponent },
  { path: 'resultsOverview', component: ResultsOverviewComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
